<script setup>
import { ref, computed, reactive, onMounted, onBeforeMount, watch } from 'vue'

const net_premium = ref(0);
const vat_percentage = ref(15);
const vat = ref(0);
const sd = ref(0);
const discount_percentage = ref(0);



onBeforeMount(() => {
  const params = new URLSearchParams(window.location.search)
  let query_net_premium = parseInt( params.get('net_premium') )
  let query_discount_percentage = parseInt( params.get('discount_percentage') )
  let query_vat_percentage = parseInt( params.get('vat_percentage') )
  let query_sd = parseInt( params.get('sd') )

  if (query_net_premium && Number.isInteger(query_net_premium)) {
    net_premium.value = query_net_premium;
  }

  if (query_discount_percentage && Number.isInteger(query_discount_percentage)) {
    discount_percentage.value = query_discount_percentage;
  }

  if (query_vat_percentage && Number.isInteger(query_vat_percentage)) {
    vat_percentage.value = query_vat_percentage;
  }

  if (query_sd && Number.isInteger(query_sd)) {
    sd.value = query_sd;
  }

  handleNetPremiumChange();

})


watch([net_premium, discount_percentage, vat_percentage, sd], ([new_net_premium, new_discount_percentage, new_vat_percentage, new_sd]) => {
  const searchURL = new URL(window.location);
  searchURL.searchParams.set('net_premium', new_net_premium);
  searchURL.searchParams.set('discount_percentage', new_discount_percentage);
  searchURL.searchParams.set('vat_percentage', new_vat_percentage);
  searchURL.searchParams.set('sd', new_sd);
  window.history.replaceState({}, '', searchURL);
})



function handleNetPremiumChange() {
  let vat_decimal = vat_percentage.value / 100;
  vat.value = Math.ceil( net_premium.value * vat_decimal );
}
const gross_premium = computed(() => {
  return net_premium.value + vat.value + sd.value;
})
const platform_discount = computed(() => {
  return Math.floor( net_premium.value * (discount_percentage.value/100) );
});
const net_sales_revenue_after_discount = computed(() => {
  return gross_premium.value - platform_discount.value;
});

const breakdown_data = [
  {
    term: 'Net Premium',
    detail: net_premium,
  },
  {
    term: 'Vat',
    detail: vat,
  },
  {
    term: 'SD',
    detail: sd,
  },
  {
    term: 'Gross Premium',
    detail: gross_premium,
  },
  {
    term: 'Discount Percentage',
    detail: discount_percentage,
    type: 'text',
  },
  {
    term: 'Platform Discount',
    detail: platform_discount,
  },
  {
    term: 'Net Sales Revenue After Discount',
    detail: net_sales_revenue_after_discount,
    type: 'price',
  },
];
</script>

<template>
  <div class="row">
    <div class="col-md-4">
      <div class="row">
        <div class="col-6">
          <div class="mb-1">
            <label for="net_premium">Net Premium</label>
            <input type="number" class="form-control" v-model.number="net_premium"  @input="handleNetPremiumChange">
          </div>
        </div>

        <div class="col-6">
          <div class="mb-1">
            <label for="vat">Vat({{vat_percentage}}%)</label>
            <input type="number" class="form-control" v-model.number="vat" >
          </div>
        </div>

        <div class="col-6">
          <div class="mb-1">
            <label for="sd">SD</label>
            <input type="number" class="form-control" v-model.number="sd" >
          </div>
        </div>
        <div class="col-6">
          <div class="mb-1">
            <label for="discount_percentage">Discount %</label>
            <input type="number" class="form-control" v-model.number="discount_percentage" >
          </div>
        </div>
      </div>
    </div>
  </div>

  <hr>
  <div class="row">
    <div class="col-md-3 col-sm-6">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Value</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in breakdown_data" :key="item.term">
            <th scope="row">{{ item.term }}</th>
            <td>{{ item.detail }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>


</template>
